export const projectTheme = {
    mainColor: '#fdc300',
    secondColor: '#fdc300',
    mainDarkColor: '#fdc300',
    secondDarkColor: '#E79F26',
    greenPrimary: '#00b2a9',

    textColor: '#000',
    linkColorCommon: '#0083FD'
}
